import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { Modal } from "antd";
import { HOTELSRIVER_OFFICIAL_LOGO_URL as Logo } from "../../../../utils/hotelsRiverBrandLogo";
import FlightLogoLoader from "../../../Loader/FlightLogoLoader";
import { usePublicSiteBranding } from "../../../../features/vacationPackagesPublic/usePublicSiteBranding";
import "./SearchLoadingModal.css";

/** מעל יומן/שכבות חיפוש גבוהות (ראה App.css) */
export const SEARCH_LOADING_MODAL_Z_INDEX = 10000200;

/**
 * מודאל טעינה אחיד לחיפוש — מלונות / חבילות / טיסות (אותו ויזואל כמו SSOT קיים).
 * באתר ציבורי: משטח מלא אטום (בלי פוטר מאחור). בדשבורד סוכן: מודאל מעל מסיכה.
 */
export default function SearchLoadingModal({
  open,
  caption,
  enableFlightsDevLogging = false,
}) {
  const prevOpenRef = useRef(open);
  const publicBranding = usePublicSiteBranding();

  useEffect(() => {
    if (!import.meta.env.DEV || !enableFlightsDevLogging) {
      prevOpenRef.current = open;
      return;
    }
    const prev = prevOpenRef.current;
    if (open && !prev) {
      console.log("[FLIGHTS_LOADING_MODAL_OPEN]");
    }
    if (!open && prev) {
      console.log("[FLIGHTS_LOADING_MODAL_CLOSE]");
    }
    prevOpenRef.current = open;
  }, [open, enableFlightsDevLogging]);

  if (publicBranding.requiresPublicSite) {
    if (!open || typeof document === "undefined") return null;
    const logoSrc =
      publicBranding.brandLogoUrl != null && String(publicBranding.brandLogoUrl).trim()
        ? String(publicBranding.brandLogoUrl).trim()
        : null;
    const brandName =
      publicBranding.brandName != null && String(publicBranding.brandName).trim()
        ? String(publicBranding.brandName).trim()
        : "";
    return createPortal(
      <div
        className="search-loading-public-cover public-site-loading-cover"
        role="status"
        aria-live="polite"
        aria-busy="true"
        aria-label={caption || "טוענים תוצאות"}
      >
        <FlightLogoLoader
          logoSrc={logoSrc}
          logoAlt={brandName || "לוגו סוכנות"}
          brandTextFallback={brandName || ""}
          caption={caption || "טוענים תוצאות"}
        />
      </div>,
      document.body
    );
  }

  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      maskClosable={false}
      centered
      width={460}
      className="search-loading-modal"
      wrapClassName="search-loading-modal-wrap"
      rootClassName="search-loading-modal-root"
      zIndex={SEARCH_LOADING_MODAL_Z_INDEX}
      getContainer={() => document.body}
      styles={{
        mask: { backgroundColor: "rgba(15, 23, 42, 0.32)" },
      }}
    >
      <div className="search-loading-modal-content">
        <FlightLogoLoader logoSrc={Logo} logoAlt="Hotels River Logo" caption={caption} />
      </div>
    </Modal>
  );
}
